import { EditorManager } from '../prosemirror/editor-manager';
import { MenuEvent } from '../prosemirror/event/menu-event';

export class MenuManager {

    constructor(
        private editorManager: EditorManager,
        private suggestionRequestEventSubscriber: ()=>void,
        private customCommandSubscriber: (event:MenuEvent)=>void,
        private suggestionsTextsSubscriber?: () => void, 
        private suggestionsEmptySubscriber?: () => void) {
    }

    onNew() {
        this.editorManager.clear();
    }
    onUndo() {
        this.editorManager.undo();
    }
    onRedo() {
        this.editorManager.redo();
    }

    onShowSuggestions() {
        this.suggestionRequestEventSubscriber();
    }

    onSuggestionsTexts() {
        this.suggestionsTextsSubscriber();
    }

    onEmptySuggestions() {
        this.suggestionsEmptySubscriber();
    }

    onCustomCommand(commandId: string) {
        const commandEvent: MenuEvent = new MenuEvent();
        commandEvent.commandId = commandId;
        commandEvent.currentTextSelected = this.editorManager.getSelectedText();
        this.customCommandSubscriber(commandEvent);
    }

}
